var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("ul", { staticClass: "search-filters-menu" }, [
        _c(
          "li",
          {
            staticClass:
              "search-filters-menu-item search-filters-menu-item__fias",
          },
          [
            _c("i", {
              staticClass: "fa fa-map-marker",
              attrs: { "aria-hidden": "true" },
            }),
            _vm._v(" "),
            _c("span", { staticClass: "search-filters-menu-item__header" }, [
              _vm._v("Местоположение"),
            ]),
            _vm._v(" "),
            _c(
              "span",
              {
                class: {
                  dashed: true,
                  "search-filter-show": true,
                  active: this.$data.shownFilter.fias,
                },
                attrs: { "data-filterType": "fias" },
                on: { click: _vm.showSingleFilter },
              },
              [_vm._v(_vm._s(_vm.selectedFiltersText.fias))]
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "li",
          {
            staticClass:
              "search-filters-menu-item search-filters-menu-item__okved",
          },
          [
            _c("i", {
              staticClass: "fa fa-wrench",
              attrs: { "aria-hidden": "true" },
            }),
            _vm._v(" "),
            _c("span", { staticClass: "search-filters-menu-item__header" }, [
              _vm._v("Вид деятельности"),
            ]),
            _vm._v(" "),
            _c(
              "span",
              {
                staticClass: "dashed search-filter-show",
                class: {
                  dashed: true,
                  "search-filter-show": true,
                  active: this.$data.shownFilter.okved,
                },
                attrs: { "data-filterType": "okved" },
                on: { click: _vm.showSingleFilter },
              },
              [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.selectedFiltersText.okved) +
                    "\n            "
                ),
              ]
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "li",
          {
            staticClass:
              "search-filters-menu-item search-filters-menu-item__okfs",
          },
          [
            _c("i", {
              staticClass: "fa fa-bank",
              attrs: { "aria-hidden": "true" },
            }),
            _vm._v(" "),
            _c("span", { staticClass: "search-filters-menu-item__header" }, [
              _vm._v("Форма собственности"),
            ]),
            _vm._v(" "),
            _c(
              "span",
              {
                staticClass: "dashed search-filter-show",
                class: {
                  dashed: true,
                  "search-filter-show": true,
                  active: this.$data.shownFilter.okfs,
                },
                attrs: { "data-filterType": "okfs" },
                on: { click: _vm.showSingleFilter },
              },
              [_vm._v(_vm._s(_vm.selectedFiltersText.okfs))]
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "li",
          {
            staticClass:
              "search-filters-menu-item search-filters-menu-item__okopf",
          },
          [
            _c("i", {
              staticClass: "fa fa-book",
              attrs: { "aria-hidden": "true" },
            }),
            _vm._v(" "),
            _c("span", { staticClass: "search-filters-menu-item__header" }, [
              _vm._v("Организационно-правовая форма"),
            ]),
            _vm._v(" "),
            _c(
              "span",
              {
                staticClass: "dashed search-filter-show",
                class: {
                  dashed: true,
                  "search-filter-show": true,
                  active: this.$data.shownFilter.okopf,
                },
                attrs: { "data-filterType": "okopf" },
                on: { click: _vm.showSingleFilter },
              },
              [_vm._v(_vm._s(_vm.selectedFiltersText.okopf))]
            ),
          ]
        ),
        _vm._v(" "),
        _c("li", { staticClass: "search-filters-menu-item" }, [
          _c("i", {
            staticClass: "fa fa-sliders",
            attrs: { "aria-hidden": "true" },
          }),
          _vm._v(" "),
          _c("span", { staticClass: "search-filters-menu-item__header" }, [
            _vm._v("Прочие фильтры"),
          ]),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dashed search-filter-show",
              class: {
                dashed: true,
                "search-filter-show": true,
                active: this.$data.shownFilter.all,
              },
              attrs: { "data-filterType": "all" },
              on: { click: _vm.showSingleFilter },
            },
            [_vm._v(_vm._s(_vm.selectedFiltersText.restFiltersText))]
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("show-result-button", { attrs: { clear: _vm.clear } }),
      _vm._v(" "),
      _c(
        "div",
        [
          _c("classificator", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.shownFilter.fias,
                expression: "shownFilter.fias",
              },
            ],
            key: 1,
            attrs: {
              title: "Местоположение",
              registry: "fias",
              inputPlaceholder: "Адрес, почтовый индекс или код ОКАТО",
            },
          }),
          _vm._v(" "),
          _c("classificator", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.shownFilter.okved,
                expression: "shownFilter.okved",
              },
            ],
            key: 2,
            attrs: {
              title: "Вид деятельности",
              registry: "okved",
              inputPlaceholder: "Название вида деятельности или код ОКВЭД",
            },
          }),
          _vm._v(" "),
          _c("classificator", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.shownFilter.okfs,
                expression: "shownFilter.okfs",
              },
            ],
            key: 3,
            attrs: {
              title: "Формы собственности",
              registry: "okfs",
              inputPlaceholder: "Название формы собственности",
            },
          }),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.shownFilter.okopf,
                  expression: "shownFilter.okopf",
                },
              ],
              staticClass: "search-filter",
            },
            [
              _c("h2", { staticClass: "search__filter-title" }, [
                _vm._v("Организационно-правовая форма"),
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "l-centered",
                  staticStyle: { "margin-top": "20px" },
                },
                [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        width: "100%",
                        "font-size": "0",
                        "text-align": "center",
                      },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "filters-group",
                          attrs: { id: "filter-okfs" },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "filters-group-outer",
                              class: { active: _vm.rectype == 0 },
                              staticStyle: {
                                width: "160px",
                                "border-radius": "4px 0 0 4px",
                              },
                              attrs: { "data-rectype": "0" },
                              on: { click: _vm.changeRecType },
                            },
                            [
                              _vm._v(
                                "\n                            Компании и ИП\n                        "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "filters-group-outer",
                              class: { active: _vm.rectype == 1 },
                              staticStyle: {
                                width: "160px",
                                "border-left": "none",
                                "border-right": "none",
                                "border-radius": "0",
                              },
                              attrs: { "data-rectype": "1" },
                              on: { click: _vm.changeRecType },
                            },
                            [
                              _vm._v(
                                "\n                            Только компании\n                        "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "filters-group-outer",
                              class: { active: _vm.rectype == 2 },
                              staticStyle: {
                                width: "160px",
                                "border-radius": "0 4px 4px 0",
                              },
                              attrs: { "data-rectype": "2" },
                              on: { click: _vm.changeRecType },
                            },
                            [
                              _vm._v(
                                "\n                            Только ИП\n                        "
                              ),
                            ]
                          ),
                        ]
                      ),
                    ]
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "blocker" },
                [
                  _vm.rectype
                    ? _c("div", { staticClass: "blocker-screen" })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("classificator", {
                    attrs: {
                      registry: "okopf",
                      inputPlaceholder:
                        "Название классификатора Организационно-правововой формы",
                    },
                  }),
                ],
                1
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.shownFilter.all,
                  expression: "shownFilter.all",
                },
              ],
              staticClass: "search-filter",
              attrs: { id: "filter-all" },
            },
            [
              _c(
                "h2",
                {
                  staticStyle: {
                    "text-align": "center",
                    "margin-bottom": "40px",
                  },
                },
                [_vm._v("Фильтры")]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "l-centered",
                  staticStyle: { "margin-top": "20px" },
                  attrs: { id: "opf__all" },
                },
                [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        width: "100%",
                        "font-size": "0",
                        "text-align": "center",
                      },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "filters-group",
                          attrs: { id: "filter-okfs" },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "filters-group-outer",
                              class: { active: _vm.rectype == 0 },
                              staticStyle: {
                                width: "160px",
                                display: "block",
                                margin: "0 auto",
                                "border-bottom-right-radius": "0",
                                "border-bottom-left-radius": "0",
                              },
                              attrs: { "data-rectype": "0" },
                              on: { click: _vm.changeRecType },
                            },
                            [
                              _vm._v(
                                "\n                            Компании и ИП\n                        "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "filters-group-outer",
                              class: { active: _vm.rectype == 1 },
                              staticStyle: {
                                width: "160px",
                                display: "block",
                                margin: "0 auto",
                                "border-radius": "0",
                                "border-top": "0",
                                "border-bottom": "0",
                              },
                              attrs: { "data-rectype": "1" },
                              on: { click: _vm.changeRecType },
                            },
                            [
                              _vm._v(
                                "\n                            Только компании\n                        "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "filters-group-outer",
                              class: { active: _vm.rectype == 2 },
                              staticStyle: {
                                width: "160px",
                                display: "block",
                                margin: "0 auto",
                                "border-top-right-radius": "0",
                                "border-top-left-radius": "0",
                              },
                              attrs: { "data-rectype": "2" },
                              on: { click: _vm.changeRecType },
                            },
                            [
                              _vm._v(
                                "\n                            Только ИП\n                        "
                              ),
                            ]
                          ),
                        ]
                      ),
                    ]
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticStyle: {
                    width: "100%",
                    "font-size": "0",
                    "text-align": "center",
                  },
                },
                [
                  _c(
                    "div",
                    { staticClass: "filters-column" },
                    [
                      _c("div", { staticClass: "filters-group" }, [
                        _c("div", { staticClass: "filters-group-label" }, [
                          _vm._v("Статус"),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "filters-group-outer",
                            class: { active: _vm.status != "both" },
                          },
                          [
                            _c(
                              "select",
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.status,
                                    expression: "status",
                                  },
                                ],
                                on: {
                                  change: [
                                    function ($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call(
                                          $event.target.options,
                                          function (o) {
                                            return o.selected
                                          }
                                        )
                                        .map(function (o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.status = $event.target.multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    },
                                    _vm.showResultsButtonFn,
                                  ],
                                },
                              },
                              [
                                _c("option", { attrs: { value: "both" } }, [
                                  _vm._v("Действующие и ликвидированные"),
                                ]),
                                _vm._v(" "),
                                _c("option", { attrs: { value: "curr" } }, [
                                  _vm._v("Действующие"),
                                ]),
                                _vm._v(" "),
                                _c("option", { attrs: { value: "liqu" } }, [
                                  _vm._v("Ликвидированные"),
                                ]),
                              ]
                            ),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "filters-group" }, [
                        _c("div", { staticClass: "filters-group-label" }, [
                          _vm._v("Дата регистрации"),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "filters-group-outer",
                            class: { active: _vm.dateStartFrom },
                            staticStyle: {
                              width: "120px",
                              "border-radius": "4px 0 0 4px",
                            },
                          },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.dateStartFrom,
                                  expression: "dateStartFrom",
                                },
                              ],
                              staticClass: "masked",
                              attrs: {
                                "data-type": "dateStart",
                                "data-fromto": "from",
                                id: "filter-date-start-from",
                                type: "text",
                                placeholder: "c",
                              },
                              domProps: { value: _vm.dateStartFrom },
                              on: {
                                keydown: _vm.showResultsButtonFn,
                                input: function ($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.dateStartFrom = $event.target.value
                                },
                              },
                            }),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "filters-group-outer",
                            class: { active: _vm.dateStartTo },
                            staticStyle: {
                              width: "120px",
                              "border-radius": "0 4px 4px 0",
                              "border-left": "none",
                            },
                          },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.dateStartTo,
                                  expression: "dateStartTo",
                                },
                              ],
                              staticClass: "masked",
                              attrs: {
                                "data-type": "dateStart",
                                "data-fromto": "to",
                                id: "filter-date-start-to",
                                type: "text",
                                placeholder: "по",
                              },
                              domProps: { value: _vm.dateStartTo },
                              on: {
                                keydown: _vm.showResultsButtonFn,
                                input: function ($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.dateStartTo = $event.target.value
                                },
                              },
                            }),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "filters-group",
                          attrs: { id: "filter-date-stop-group" },
                        },
                        [
                          _c("div", { staticClass: "filters-group-label" }, [
                            _vm._v("Дата ликвидации"),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "filters-group-outer",
                              class: { active: _vm.dateStopFrom },
                              staticStyle: {
                                width: "120px",
                                "border-radius": "4px 0 0 4px",
                              },
                            },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.dateStopFrom,
                                    expression: "dateStopFrom",
                                  },
                                ],
                                staticClass: "masked",
                                attrs: {
                                  "data-type": "dateStop",
                                  "data-fromto": "from",
                                  id: "filter-date-stop-from",
                                  type: "text",
                                  placeholder: "c",
                                },
                                domProps: { value: _vm.dateStopFrom },
                                on: {
                                  keydown: _vm.showResultsButtonFn,
                                  input: function ($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.dateStopFrom = $event.target.value
                                  },
                                },
                              }),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "filters-group-outer",
                              class: { active: _vm.dateStopTo },
                              staticStyle: {
                                width: "120px",
                                "border-radius": "0 4px 4px 0",
                                "border-left": "none",
                              },
                            },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.dateStopTo,
                                    expression: "dateStopTo",
                                  },
                                ],
                                staticClass: "masked",
                                attrs: {
                                  "data-type": "dateStop",
                                  "data-fromto": "to",
                                  id: "filter-date-stop-to",
                                  type: "text",
                                  placeholder: "по",
                                },
                                domProps: { value: _vm.dateStopTo },
                                on: {
                                  keydown: _vm.showResultsButtonFn,
                                  input: function ($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.dateStopTo = $event.target.value
                                  },
                                },
                              }),
                            ]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "filters-group",
                          attrs: { id: "filter-contacts" },
                        },
                        [
                          _c("div", { staticClass: "filters-group-label" }, [
                            _vm._v("С контактами"),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "filters-group-outer",
                              class: { active: _vm.phone },
                              staticStyle: {
                                width: "80px",
                                "border-radius": "4px 0 0 4px",
                              },
                            },
                            [
                              _c(
                                "label",
                                {
                                  staticClass: "filters-checkbox",
                                  attrs: {
                                    for: "filter-data-contacts-phone",
                                    id: "filter-contacts-phone",
                                  },
                                },
                                [_vm._v("Телефон")]
                              ),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.phone,
                                    expression: "phone",
                                  },
                                ],
                                staticStyle: { visibility: "hidden" },
                                attrs: {
                                  value: "phone",
                                  type: "checkbox",
                                  name: "filter-data-contacts",
                                  id: "filter-data-contacts-phone",
                                },
                                domProps: {
                                  checked: Array.isArray(_vm.phone)
                                    ? _vm._i(_vm.phone, "phone") > -1
                                    : _vm.phone,
                                },
                                on: {
                                  change: [
                                    function ($event) {
                                      var $$a = _vm.phone,
                                        $$el = $event.target,
                                        $$c = $$el.checked ? true : false
                                      if (Array.isArray($$a)) {
                                        var $$v = "phone",
                                          $$i = _vm._i($$a, $$v)
                                        if ($$el.checked) {
                                          $$i < 0 &&
                                            (_vm.phone = $$a.concat([$$v]))
                                        } else {
                                          $$i > -1 &&
                                            (_vm.phone = $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1)))
                                        }
                                      } else {
                                        _vm.phone = $$c
                                      }
                                    },
                                    _vm.showResultsButtonFn,
                                  ],
                                },
                              }),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "filters-group-outer",
                              class: { active: _vm.site },
                              staticStyle: {
                                width: "80px",
                                "border-left": "none",
                                "border-right": "none",
                                "border-radius": "0",
                              },
                            },
                            [
                              _c(
                                "label",
                                {
                                  staticClass: "filters-checkbox",
                                  attrs: {
                                    for: "filter-data-contacts-site",
                                    id: "filter-contacts-site",
                                  },
                                },
                                [_vm._v("Сайт")]
                              ),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.site,
                                    expression: "site",
                                  },
                                ],
                                staticStyle: { visibility: "hidden" },
                                attrs: {
                                  value: "site",
                                  type: "checkbox",
                                  name: "filter-data-contacts",
                                  id: "filter-data-contacts-site",
                                },
                                domProps: {
                                  checked: Array.isArray(_vm.site)
                                    ? _vm._i(_vm.site, "site") > -1
                                    : _vm.site,
                                },
                                on: {
                                  change: [
                                    function ($event) {
                                      var $$a = _vm.site,
                                        $$el = $event.target,
                                        $$c = $$el.checked ? true : false
                                      if (Array.isArray($$a)) {
                                        var $$v = "site",
                                          $$i = _vm._i($$a, $$v)
                                        if ($$el.checked) {
                                          $$i < 0 &&
                                            (_vm.site = $$a.concat([$$v]))
                                        } else {
                                          $$i > -1 &&
                                            (_vm.site = $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1)))
                                        }
                                      } else {
                                        _vm.site = $$c
                                      }
                                    },
                                    _vm.showResultsButtonFn,
                                  ],
                                },
                              }),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "filters-group-outer",
                              class: { active: _vm.email },
                              staticStyle: {
                                width: "80px",
                                "border-radius": "0 4px 4px 0",
                              },
                            },
                            [
                              _c(
                                "label",
                                {
                                  staticClass: "filters-checkbox",
                                  attrs: {
                                    for: "filter-data-contacts-email",
                                    id: "filter-contacts-email",
                                  },
                                },
                                [_vm._v("Эл. почта")]
                              ),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.email,
                                    expression: "email",
                                  },
                                ],
                                staticStyle: { visibility: "hidden" },
                                attrs: {
                                  value: "email",
                                  type: "checkbox",
                                  name: "filter-data-contacts",
                                  id: "filter-data-contacts-email",
                                },
                                domProps: {
                                  checked: Array.isArray(_vm.email)
                                    ? _vm._i(_vm.email, "email") > -1
                                    : _vm.email,
                                },
                                on: {
                                  change: [
                                    function ($event) {
                                      var $$a = _vm.email,
                                        $$el = $event.target,
                                        $$c = $$el.checked ? true : false
                                      if (Array.isArray($$a)) {
                                        var $$v = "email",
                                          $$i = _vm._i($$a, $$v)
                                        if ($$el.checked) {
                                          $$i < 0 &&
                                            (_vm.email = $$a.concat([$$v]))
                                        } else {
                                          $$i > -1 &&
                                            (_vm.email = $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1)))
                                        }
                                      } else {
                                        _vm.email = $$c
                                      }
                                    },
                                    _vm.showResultsButtonFn,
                                  ],
                                },
                              }),
                            ]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("search-filter-checkbox", {
                        attrs: {
                          buttonTitle: "Есть связь по юр. адресу",
                          type: "registration_adress_contact",
                        },
                      }),
                      _vm._v(" "),
                      _c("search-filter-checkbox", {
                        attrs: {
                          buttonTitle: "Сдана налоговая отчётность",
                          type: "nalog_otchet",
                        },
                      }),
                      _vm._v(" "),
                      _c("search-filter-checkbox", {
                        attrs: {
                          buttonTitle: "Без задолженности по налогам",
                          type: "nalog_zadolj",
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        { attrs: { id: "filter-license" } },
                        [
                          _c("search-filter-checkbox", {
                            attrs: {
                              group: true,
                              type: "license_alco",
                              buttonTitle: "Росалкогольрегулирование",
                              title: "Наличие лицензий",
                            },
                          }),
                          _vm._v(" "),
                          _c("search-filter-checkbox", {
                            attrs: {
                              group: true,
                              type: "license_zdrav",
                              buttonTitle: "Росздравнадзор",
                            },
                          }),
                          _vm._v(" "),
                          _c("search-filter-checkbox", {
                            attrs: {
                              group: true,
                              type: "license_kom",
                              buttonTitle: "Роскомнадзор",
                            },
                          }),
                          _vm._v(" "),
                          _c("search-filter-checkbox", {
                            attrs: {
                              group: true,
                              type: "license_potreb",
                              buttonTitle: "Роспотребнадзор",
                            },
                          }),
                          _vm._v(" "),
                          _c("search-filter-checkbox", {
                            attrs: {
                              group: true,
                              type: "license_prirod",
                              buttonTitle: "Росприроднадзор",
                            },
                          }),
                          _vm._v(" "),
                          _c("search-filter-checkbox", {
                            attrs: {
                              group: true,
                              type: "license_teh",
                              buttonTitle: "Ростехнадзор",
                            },
                          }),
                          _vm._v(" "),
                          _c("search-filter-checkbox", {
                            attrs: {
                              group: true,
                              type: "license_obr",
                              buttonTitle: "Рособрнадзор",
                            },
                          }),
                          _vm._v(" "),
                          _c("search-filter-checkbox", {
                            attrs: {
                              group: true,
                              type: "license_min_cult",
                              buttonTitle: "МинКультуры",
                            },
                          }),
                          _vm._v(" "),
                          _c("search-filter-checkbox", {
                            attrs: {
                              group: true,
                              type: "license_min_promtorg",
                              buttonTitle: "МинПромторг",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "filters-column" },
                    [
                      _c("search-money-filter", {
                        attrs: {
                          title: "Уставный капитал *",
                          type: "auth_capital",
                        },
                      }),
                      _vm._v(" "),
                      _c("search-money-filter", {
                        attrs: { title: "Выручка *", type: "p21103" },
                      }),
                      _vm._v(" "),
                      _c("search-money-filter", {
                        attrs: { title: "Основные средства *", type: "p11503" },
                      }),
                      _vm._v(" "),
                      _c("search-money-filter", {
                        attrs: { title: "Запасы *", type: "p12103" },
                      }),
                      _vm._v(" "),
                      _c("search-money-filter", {
                        attrs: {
                          title: "Деб. задолженность *",
                          type: "p12303",
                        },
                      }),
                      _vm._v(" "),
                      _c("search-money-filter", {
                        attrs: {
                          title: "Кред. задолженность *",
                          type: "p15203",
                        },
                      }),
                      _vm._v(" "),
                      _c("search-money-filter", {
                        attrs: { title: "Чистая прибыль *", type: "p24003" },
                      }),
                      _vm._v(" "),
                      _c("search-money-filter", {
                        attrs: { title: "Прибыль от продаж *", type: "p22003" },
                      }),
                      _vm._v(" "),
                      _c("search-money-filter", {
                        attrs: { title: "Прибыль до налога *", type: "p23003" },
                      }),
                      _vm._v(" "),
                      _vm._m(0),
                      _vm._v(" "),
                      _c("div", { staticClass: "filters-group" }, [
                        _c("div", { staticClass: "filters-group-label" }, [
                          _vm._v(
                            "\n                            Иски о банкротстве\n                        "
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "filters-group-outer",
                            class: { active: _vm.bankrupts },
                          },
                          [
                            _c(
                              "select",
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.bankrupts,
                                    expression: "bankrupts",
                                  },
                                ],
                                on: {
                                  change: [
                                    function ($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call(
                                          $event.target.options,
                                          function (o) {
                                            return o.selected
                                          }
                                        )
                                        .map(function (o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.bankrupts = $event.target.multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    },
                                    _vm.showResultsButtonFn,
                                  ],
                                },
                              },
                              [
                                _c("option", { attrs: { value: "0" } }, [
                                  _vm._v("Не важно"),
                                ]),
                                _vm._v(" "),
                                _c("option", { attrs: { value: "1" } }, [
                                  _vm._v("Есть"),
                                ]),
                                _vm._v(" "),
                                _c("option", { attrs: { value: "2" } }, [
                                  _vm._v("Нет"),
                                ]),
                              ]
                            ),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "filters-group" }, [
                        _c("div", { staticClass: "filters-group-label" }, [
                          _vm._v(
                            "\n                            Бух. отчетность\n                        "
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "filters-group-outer",
                            class: { active: _vm.boo_year },
                          },
                          [
                            _c(
                              "select",
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.boo_year,
                                    expression: "boo_year",
                                  },
                                ],
                                on: {
                                  change: [
                                    function ($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call(
                                          $event.target.options,
                                          function (o) {
                                            return o.selected
                                          }
                                        )
                                        .map(function (o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.boo_year = $event.target.multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    },
                                    _vm.showResultsButtonFn,
                                  ],
                                },
                              },
                              [
                                _c("option", { attrs: { value: "" } }, [
                                  _vm._v("Наличие за год"),
                                ]),
                                _vm._v(" "),
                                _c("option", { attrs: { value: "2018" } }, [
                                  _vm._v("2018"),
                                ]),
                                _vm._v(" "),
                                _c("option", { attrs: { value: "2017" } }, [
                                  _vm._v("2017"),
                                ]),
                                _vm._v(" "),
                                _c("option", { attrs: { value: "2016" } }, [
                                  _vm._v("2016"),
                                ]),
                                _vm._v(" "),
                                _c("option", { attrs: { value: "2015" } }, [
                                  _vm._v("2015"),
                                ]),
                                _vm._v(" "),
                                _c("option", { attrs: { value: "2014" } }, [
                                  _vm._v("2014"),
                                ]),
                                _vm._v(" "),
                                _c("option", { attrs: { value: "2013" } }, [
                                  _vm._v("2013"),
                                ]),
                                _vm._v(" "),
                                _c("option", { attrs: { value: "2012" } }, [
                                  _vm._v("2012"),
                                ]),
                                _vm._v(" "),
                                _c("option", { attrs: { value: "2011" } }, [
                                  _vm._v("2011"),
                                ]),
                                _vm._v(" "),
                                _c("option", { attrs: { value: "2010" } }, [
                                  _vm._v("2010"),
                                ]),
                                _vm._v(" "),
                                _c("option", { attrs: { value: "2009" } }, [
                                  _vm._v("2009"),
                                ]),
                                _vm._v(" "),
                                _c("option", { attrs: { value: "2008" } }, [
                                  _vm._v("2008"),
                                ]),
                                _vm._v(" "),
                                _c("option", { attrs: { value: "2007" } }, [
                                  _vm._v("2007"),
                                ]),
                                _vm._v(" "),
                                _c("option", { attrs: { value: "2006" } }, [
                                  _vm._v("2006"),
                                ]),
                                _vm._v(" "),
                                _c("option", { attrs: { value: "2005" } }, [
                                  _vm._v("2005"),
                                ]),
                                _vm._v(" "),
                                _c("option", { attrs: { value: "2004" } }, [
                                  _vm._v("2004"),
                                ]),
                                _vm._v(" "),
                                _c("option", { attrs: { value: "2003" } }, [
                                  _vm._v("2003"),
                                ]),
                                _vm._v(" "),
                                _c("option", { attrs: { value: "2002" } }, [
                                  _vm._v("2002"),
                                ]),
                                _vm._v(" "),
                                _c("option", { attrs: { value: "2001" } }, [
                                  _vm._v("2001"),
                                ]),
                              ]
                            ),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "filters-group" }, [
                        _c("div", { staticClass: "filters-group-label" }, [
                          _vm._v(
                            "\n                            Участие в ВЭД\n                        "
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "filters-group-outer filters-group-outer__1x2",
                            class: { active: _vm.vedType },
                          },
                          [
                            _c(
                              "select",
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.vedType,
                                    expression: "vedType",
                                  },
                                ],
                                on: {
                                  change: [
                                    function ($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call(
                                          $event.target.options,
                                          function (o) {
                                            return o.selected
                                          }
                                        )
                                        .map(function (o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.vedType = $event.target.multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    },
                                    _vm.showResultsButtonFn,
                                  ],
                                },
                              },
                              [
                                _c("option", { attrs: { value: "" } }, [
                                  _vm._v("Тип"),
                                ]),
                                _vm._v(" "),
                                _c("option", { attrs: { value: "1" } }, [
                                  _vm._v("Контрактодержатель"),
                                ]),
                                _vm._v(" "),
                                _c("option", { attrs: { value: "2" } }, [
                                  _vm._v("Декларант"),
                                ]),
                                _vm._v(" "),
                                _c("option", { attrs: { value: "3" } }, [
                                  _vm._v("Получатель"),
                                ]),
                                _vm._v(" "),
                                _c("option", { attrs: { value: "4" } }, [
                                  _vm._v("Отправитель"),
                                ]),
                              ]
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "filters-group-outer filters-group-outer__2x2",
                            class: { active: _vm.vedYear },
                          },
                          [
                            _c(
                              "select",
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.vedYear,
                                    expression: "vedYear",
                                  },
                                ],
                                on: {
                                  change: [
                                    function ($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call(
                                          $event.target.options,
                                          function (o) {
                                            return o.selected
                                          }
                                        )
                                        .map(function (o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.vedYear = $event.target.multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    },
                                    _vm.showResultsButtonFn,
                                  ],
                                },
                              },
                              [
                                _c("option", { attrs: { value: "" } }, [
                                  _vm._v("Год"),
                                ]),
                                _vm._v(" "),
                                _c("option", { attrs: { value: "2015" } }, [
                                  _vm._v("2015"),
                                ]),
                                _vm._v(" "),
                                _c("option", { attrs: { value: "2014" } }, [
                                  _vm._v("2014"),
                                ]),
                                _vm._v(" "),
                                _c("option", { attrs: { value: "2013" } }, [
                                  _vm._v("2013"),
                                ]),
                                _vm._v(" "),
                                _c("option", { attrs: { value: "2012" } }, [
                                  _vm._v("2012"),
                                ]),
                                _vm._v(" "),
                                _c("option", { attrs: { value: "2011" } }, [
                                  _vm._v("2011"),
                                ]),
                                _vm._v(" "),
                                _c("option", { attrs: { value: "2010" } }, [
                                  _vm._v("2010"),
                                ]),
                                _vm._v(" "),
                                _c("option", { attrs: { value: "2009" } }, [
                                  _vm._v("2009"),
                                ]),
                                _vm._v(" "),
                                _c("option", { attrs: { value: "2008" } }, [
                                  _vm._v("2008"),
                                ]),
                                _vm._v(" "),
                                _c("option", { attrs: { value: "2007" } }, [
                                  _vm._v("2007"),
                                ]),
                                _vm._v(" "),
                                _c("option", { attrs: { value: "2006" } }, [
                                  _vm._v("2006"),
                                ]),
                                _vm._v(" "),
                                _c("option", { attrs: { value: "2005" } }, [
                                  _vm._v("2005"),
                                ]),
                                _vm._v(" "),
                                _c("option", { attrs: { value: "2004" } }, [
                                  _vm._v("2004"),
                                ]),
                                _vm._v(" "),
                                _c("option", { attrs: { value: "2003" } }, [
                                  _vm._v("2003"),
                                ]),
                                _vm._v(" "),
                                _c("option", { attrs: { value: "2002" } }, [
                                  _vm._v("2002"),
                                ]),
                                _vm._v(" "),
                                _c("option", { attrs: { value: "2001" } }, [
                                  _vm._v("2001"),
                                ]),
                                _vm._v(" "),
                                _c("option", { attrs: { value: "2000" } }, [
                                  _vm._v("2000"),
                                ]),
                                _vm._v(" "),
                                _c("option", { attrs: { value: "1999" } }, [
                                  _vm._v("1999"),
                                ]),
                                _vm._v(" "),
                                _c("option", { attrs: { value: "1998" } }, [
                                  _vm._v("1998"),
                                ]),
                              ]
                            ),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "filters-group" }, [
                        _c("div", { staticClass: "filters-group-label" }, [
                          _vm._v(
                            "\n                            Арбитражи\n                        "
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "filters-group-outer filters-group-outer__1x2",
                            class: { active: _vm.kadType != "noselect" },
                          },
                          [
                            _c(
                              "select",
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.kadType,
                                    expression: "kadType",
                                  },
                                ],
                                on: {
                                  change: [
                                    function ($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call(
                                          $event.target.options,
                                          function (o) {
                                            return o.selected
                                          }
                                        )
                                        .map(function (o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.kadType = $event.target.multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    },
                                    _vm.showResultsButtonFn,
                                  ],
                                },
                              },
                              [
                                _c("option", { attrs: { value: "noselect" } }, [
                                  _vm._v("Тип"),
                                ]),
                                _vm._v(" "),
                                _c("option", { attrs: { value: "0" } }, [
                                  _vm._v("Истец"),
                                ]),
                                _vm._v(" "),
                                _c("option", { attrs: { value: "1" } }, [
                                  _vm._v("Ответчик"),
                                ]),
                                _vm._v(" "),
                                _c("option", { attrs: { value: "2" } }, [
                                  _vm._v("3я сторона"),
                                ]),
                              ]
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "filters-group-outer filters-group-outer__2x2",
                            class: { active: _vm.kadYear },
                          },
                          [
                            _c(
                              "select",
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.kadYear,
                                    expression: "kadYear",
                                  },
                                ],
                                on: {
                                  change: [
                                    function ($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call(
                                          $event.target.options,
                                          function (o) {
                                            return o.selected
                                          }
                                        )
                                        .map(function (o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.kadYear = $event.target.multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    },
                                    _vm.showResultsButtonFn,
                                  ],
                                },
                              },
                              [
                                _c("option", { attrs: { value: "" } }, [
                                  _vm._v("Год"),
                                ]),
                                _vm._v(" "),
                                _c("option", { attrs: { value: "2019" } }, [
                                  _vm._v("2019"),
                                ]),
                                _vm._v(" "),
                                _c("option", { attrs: { value: "2018" } }, [
                                  _vm._v("2018"),
                                ]),
                                _vm._v(" "),
                                _c("option", { attrs: { value: "2017" } }, [
                                  _vm._v("2017"),
                                ]),
                                _vm._v(" "),
                                _c("option", { attrs: { value: "2016" } }, [
                                  _vm._v("2016"),
                                ]),
                                _vm._v(" "),
                                _c("option", { attrs: { value: "2015" } }, [
                                  _vm._v("2015"),
                                ]),
                                _vm._v(" "),
                                _c("option", { attrs: { value: "2014" } }, [
                                  _vm._v("2014"),
                                ]),
                                _vm._v(" "),
                                _c("option", { attrs: { value: "2013" } }, [
                                  _vm._v("2013"),
                                ]),
                                _vm._v(" "),
                                _c("option", { attrs: { value: "2012" } }, [
                                  _vm._v("2012"),
                                ]),
                                _vm._v(" "),
                                _c("option", { attrs: { value: "2011" } }, [
                                  _vm._v("2011"),
                                ]),
                                _vm._v(" "),
                                _c("option", { attrs: { value: "2010" } }, [
                                  _vm._v("2010"),
                                ]),
                                _vm._v(" "),
                                _c("option", { attrs: { value: "2009" } }, [
                                  _vm._v("2009"),
                                ]),
                                _vm._v(" "),
                                _c("option", { attrs: { value: "2008" } }, [
                                  _vm._v("2008"),
                                ]),
                                _vm._v(" "),
                                _c("option", { attrs: { value: "2007" } }, [
                                  _vm._v("2007"),
                                ]),
                                _vm._v(" "),
                                _c("option", { attrs: { value: "2006" } }, [
                                  _vm._v("2006"),
                                ]),
                                _vm._v(" "),
                                _c("option", { attrs: { value: "2005" } }, [
                                  _vm._v("2005"),
                                ]),
                                _vm._v(" "),
                                _c("option", { attrs: { value: "2004" } }, [
                                  _vm._v("2004"),
                                ]),
                                _vm._v(" "),
                                _c("option", { attrs: { value: "2003" } }, [
                                  _vm._v("2003"),
                                ]),
                                _vm._v(" "),
                                _c("option", { attrs: { value: "2002" } }, [
                                  _vm._v("2002"),
                                ]),
                                _vm._v(" "),
                                _c("option", { attrs: { value: "2001" } }, [
                                  _vm._v("2001"),
                                ]),
                                _vm._v(" "),
                                _c("option", { attrs: { value: "2000" } }, [
                                  _vm._v("2000"),
                                ]),
                                _vm._v(" "),
                                _c("option", { attrs: { value: "1999" } }, [
                                  _vm._v("1999"),
                                ]),
                                _vm._v(" "),
                                _c("option", { attrs: { value: "1998" } }, [
                                  _vm._v("1998"),
                                ]),
                              ]
                            ),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "filters-group" }, [
                        _c("div", { staticClass: "filters-group-label" }, [
                          _vm._v(
                            "\n                            Размер предприятия\n                        "
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "filters-group-outer",
                            class: { active: _vm.msp },
                          },
                          [
                            _c(
                              "select",
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.msp,
                                    expression: "msp",
                                  },
                                ],
                                on: {
                                  change: [
                                    function ($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call(
                                          $event.target.options,
                                          function (o) {
                                            return o.selected
                                          }
                                        )
                                        .map(function (o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.msp = $event.target.multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    },
                                    _vm.showResultsButtonFn,
                                  ],
                                },
                              },
                              [
                                _c("option", { domProps: { value: 0 } }, [
                                  _vm._v("Все предприятия"),
                                ]),
                                _vm._v(" "),
                                _c("option", { domProps: { value: 10 } }, [
                                  _vm._v("Микро"),
                                ]),
                                _vm._v(" "),
                                _c("option", { domProps: { value: 11 } }, [
                                  _vm._v("Малые"),
                                ]),
                                _vm._v(" "),
                                _c("option", { domProps: { value: 12 } }, [
                                  _vm._v("Средние"),
                                ]),
                              ]
                            ),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _vm.showEmployeeCount
                        ? _c("div", { staticClass: "filters-group" }, [
                            _c("div", { staticClass: "filters-group-label" }, [
                              _vm._v("Кол-во сотрудников"),
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "filters-group-outer",
                                staticStyle: {
                                  width: "120px",
                                  "border-radius": "4px 0 0 4px",
                                },
                              },
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.employeeCountFrom,
                                      expression: "employeeCountFrom",
                                    },
                                  ],
                                  attrs: {
                                    "data-fromto": "from",
                                    type: "text",
                                    placeholder: "от",
                                  },
                                  domProps: { value: _vm.employeeCountFrom },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.employeeCountFrom =
                                        $event.target.value
                                    },
                                  },
                                }),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "filters-group-outer",
                                staticStyle: {
                                  width: "120px",
                                  "border-radius": "0 4px 4px 0",
                                  "border-left": "none",
                                },
                              },
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.employeeCountTo,
                                      expression: "employeeCountTo",
                                    },
                                  ],
                                  attrs: {
                                    "data-fromto": "to",
                                    type: "text",
                                    placeholder: "до",
                                  },
                                  domProps: { value: _vm.employeeCountTo },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.employeeCountTo = $event.target.value
                                    },
                                  },
                                }),
                              ]
                            ),
                          ])
                        : _vm._e(),
                    ],
                    1
                  ),
                ]
              ),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "filters-group" }, [
      _c("div", { staticClass: "filters-group-label" }, [
        _vm._v(
          "\n                            * - используются данные за последний отчётный период\n                        "
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }